import { Navigate, createFileRoute, useRouterState } from '@tanstack/react-router';
import { getWorkspaceScopedPath } from '../components/app-sidebar-nav.js';

export const Route = createFileRoute('/settings')({
  component: SettingsIndexPage,
});

export function SettingsIndexPage() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  return <Navigate to={getWorkspaceScopedPath(pathname, '/settings/profile')} replace />;
}
